import { FormikErrors } from 'formik';
import { getTrans } from 'modules/i18n';
import { EducationEntry } from 'utils/cv-form-db';
import { isRequired } from '../../utils';

export const generateSemesterOptions = () => {
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const currentMonth = currentDate.getMonth() + 1;

  const getCurrentSemester = () => {
    if (currentMonth >= 10 || currentMonth <= 3) {
      if (currentMonth >= 10) {
        return `WS ${currentYear}/${(currentYear + 1).toString().slice(-2)}`;
      } else {
        return `WS ${currentYear - 1}/${currentYear.toString().slice(-2)}`;
      }
    } else {
      return `SS ${currentYear}`;
    }
  };

  const options = [];
  const currentSemester = getCurrentSemester();

  for (let year = 1950; year <= currentYear + 10; year++) {
    options.push({
      value: `SS ${year}`,
      label: `SS ${year}`
    });

    options.push({
      value: `WS ${year}/${(year + 1).toString().slice(-2)}`,
      label: `WS ${year}/${(year + 1).toString().slice(-2)}`
    });
  }

  return { options, currentSemester };
};

export const compareSemesters = (
  semester1: string,
  semester2: string
): number => {
  if (!semester1 || !semester2) return 0;

  const parseSemester = (semester: string) => {
    if (semester.startsWith('SS')) {
      const year = parseInt(semester.split(' ')[1]);
      return { year, type: 'SS', sortValue: year * 2 };
    } else if (semester.startsWith('WS')) {
      const yearPart = semester.split(' ')[1];
      const year = parseInt(yearPart.split('/')[0]);
      return { year, type: 'WS', sortValue: year * 2 + 1 };
    }
    return { year: 0, type: '', sortValue: 0 };
  };

  const sem1 = parseSemester(semester1);
  const sem2 = parseSemester(semester2);

  return sem1.sortValue - sem2.sortValue;
};

export const isEducationComplete = (values: EducationEntry) => {
  if (!Object.values(values).length) {
    return false;
  }

  const formErrors = validateEducation(values);

  return Object.keys(formErrors).length === 0;
};

export const validateEducation = (education: EducationEntry) => {
  const errors: FormikErrors<EducationEntry> = {};

  const currentlyEnrolled = education.currentlyEnrolled;

  const fieldsToValidate = [
    {
      field: 'university',
      message: getTrans(
        'cvBuilderPage.education.form.university.required.label'
      )
    },
    {
      field: 'study',
      message: getTrans('cvBuilderPage.education.form.study.required.label')
    },
    {
      field: 'degree',
      message: currentlyEnrolled
        ? getTrans('cvBuilderPage.education.form.expectedDegree.required.label')
        : getTrans('cvBuilderPage.education.form.degree.required.label')
    },
    {
      field: 'studyStart',
      message: getTrans('cvBuilderPage.education.form.startDate.required.label')
    },
    {
      field: 'studyEnd',
      message: currentlyEnrolled
        ? getTrans(
            'cvBuilderPage.education.form.expectedEndDate.required.label'
          )
        : getTrans('cvBuilderPage.education.form.endDate.required.label')
    }
  ] as const;

  fieldsToValidate.forEach(({ field, message }) => {
    if (isRequired(education[field as keyof EducationEntry] as string)) {
      errors[field] = message;
    }
  });

  return errors;
};
